import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const formularioForm: AnaColumn[] = [
    {
      itemType: "group", groupDataField: 'produttore', disabled: false, caption: "Produttore o Dententore", colCount: "4", data: [
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'copiaDatiAziendaProduttore', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Copia I dati azienda', hideOnEdit: false,
  
          checkBox: {
            event: {
              type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
              key: 'copiaDatiAziendaProduttore'
  
  
            }
  
          },
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: "identificativoSito", dataType: "", hideOnEdit: false, caption: "Unità Locale",
          width: 42 * aspect, maxSize: 42,
          disabled: true, readonly: true
  
        },
        {
          type: 'campoData', colVisible: false, dataField: "dataEmissione", dataType: "datetime", editorType: "dxDateBox", hideOnEdit: false, caption: "Data Emissione FIR",
          maxLength: '42', width: 42 * aspect, maxSize: 42, format: "dd/MM/yyyy",
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
  
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Dati Produttore", colSpan: '4' },
  
        {
          type: 'campo', colVisible: false, dataField: 'produttoreDenominazione', caption: 'Ragione Sociale', dataType: "", hideOnEdit: false,
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
          required: true,
          class: "required",
          validation: [
  
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'produttoreCodiceFiscale', caption: 'Codice Fiscale', dataType: "", hideOnEdit: false,
          maxSize: 45,
          maxLength: "13",
          width: 49.87 * aspect,
          required: true,
          class: "required", validation: [
  
            { type: "required", message: "Campo Obbligatorio" },
            { type: "stringLength", min: "11", max: "16", message: "Codice Fiscale non valido" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
  
        /*{
          type: 'campoButton', dataField: "produttoreContattoButton", colVisible: true, caption: "Contatto.", dataType: "",
          maxLength: '30', width: 49.87 * aspect, maxSize: 30,  class:'buttonFormulario',
  
          button: {
            text: '',
            name: 'infoContattoSede',
            type:'text',
            componentType: 'ContattiComponent',
            location: 'after',
            event: "OptionalIconButtonClick",
            hint: "ottieni le informazioni del contatto",
            icon: "glyphicon mdi mdi-file-search-outline",
            outPutValue:false,
            related:['nome|produttoreNome','cognome|produttoreCognome','telUfficio|produttoreTelefono','email|produttoreEmail']
           
          }
        },
  
          
        
        
        
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: "produttoreNome", dataType: "", hideOnEdit: false, caption: "Nome",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: "produttoreCognome", dataType: "", hideOnEdit: false, caption: "Cognome",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: "produttoreTelefono", dataType: "", hideOnEdit: false, caption: "Telefono",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: "produttoreEmail", dataType: "", hideOnEdit: false, caption: "Email",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  */
        {
          type: 'campo', colVisible: false, dataField: 'produttoreVia', dataType: "", hideOnEdit: false, caption: "Indirizzo",
          width: 49.87 * aspect,
          required: true,
          class: "required", validation: [
  
            { type: "required", message: "Campo Obbligatorio" },
  
          ],
        },
        {
          type: 'campo', colVisible: false, dataField: 'produttoreCivico', dataType: "", hideOnEdit: false, caption: "Civico",
          width: 7 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        { type: 'campo', colVisible: false, dataField: 'produttoreCitta', dataType: "", hideOnEdit: false, caption: "Frazione", width: 49.87 * aspect, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campoSpecial', dataField: "produttoreComune", caption: "Comune", dataType: "",
          required: true,
          class: 'required',
          labelAlignment: "righr",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 45,
  
          width: 49.87 * aspect,
  
          dynamic: {
            costantValue: [{ key: 'produttorePaese', value: 'IT' }],
            dataSource: 'comune',
            autocomplete: true,
            checkValue: {
              checkValueMessage: 'Comune inesistente, vuoi continuare?',
              forceInsert: false
            },
            valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
            displayExpr: 'descrizione',
            caption: "Comuni",
            queryString: '?take=8000',
            componentType: 'grid',
  
            related: ['cap|produttoreCap', 'siglaProvincia|produttoreSiglaProvincia', 'provincia|produttoreProvincia', 'id|produttoreComuneIstat'],
            buttonOption: {
              text: 'Comuni',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Comuni',
              name: 'Comuni',
              location: 'after',
            },
  
          }
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'produttorePaese', dataType: "", hideOnEdit: false, caption: "Stato",
          maxSize: 2,
          maxLength: "2",
          width: 25 * aspect,
          required: true,
          class: "required",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'StatoEstero',
            valueExpr: 'iso',
            displayExpr: 'descrizione',
            static: false
          },
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'produttoreCap', dataType: "", hideOnEdit: false, caption: "CAP",
          width: 8 * aspect,
          maxSize: 5,
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: "produttoreSiglaProvincia", dataType: "", hideOnEdit: false, caption: "Provincia",
          maxSize: 2,
          maxLength: "2",
          width: 20 * aspect,
          required: true,
          class: "required", validation: [
  
            { type: "required", message: "Campo Obbligatorio" }
          ],
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'provincia',
            valueExpr: 'siglaProvincia',
            displayExpr: 'descrizione',
            static: false,
            related: ['descrizione|produttoreProvincia']
  
          }
        },
        {
          type: 'campo', colVisible: false, dataField: 'produttoreComuneIstat', dataType: "", hideOnEdit: false, caption: "istat",
          width: 25.7 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Luogo Produzione", colSpan: '4' },
        {
          type: 'campo', colVisible: false, dataField: 'luogoProdVia', dataType: "", hideOnEdit: false, caption: "Indirizzo",
          maxSize: 45,
          width: 49.87 * aspect,
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'luogoProdCivico', dataType: "", hideOnEdit: false, caption: "Civico",
          maxSize: 7,
          maxLength: "7",
          width: 7 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'luogoProdCitta', dataType: "", hideOnEdit: false, caption: "Citta",
          width: 49.87 * aspect,
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'luogoProdComune', dataType: "", hideOnEdit: false, caption: "Comune",
          maxSize: 45,
          width: 49.87 * aspect,
          dynamic: {
  
            dataSource: 'comune',
            autocomplete: true,
            checkValue: {
              checkValueMessage: '',
              forceInsert: true
            },
            valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
            displayExpr: 'descrizione',
            caption: "Lista Comuni",
            componentType: 'grid',
            enableEditor: {
              add:true,
              remove:true,
              update:true
            },
            related: ['cap|luogoProdCap', 'siglaProvincia|luogoProdSiglaProvincia', 'provincia|luogoProdProvincia', 'id|luogoProdComuneIstat'],
            buttonOption: {
              text: 'Comuni',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Comuni',
              name: 'Comuni',
              location: 'after',
            },
  
          }
  
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'luogoProdPaeseId', dataType: "", hideOnEdit: false, caption: "Stato",
          maxSize: 2,
          maxLength: "2",
          width: 24.8 * aspect,
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'statoEstero',
            valueExpr: 'iso',
            displayExpr: 'descrizione',
            static: false,
  
          }
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'luogoProdCap', dataType: "", hideOnEdit: false, caption: "Cap",
          maxSize: 5,
          maxLength: "5",
          width: 8 * aspect,
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'luogoProdSiglaProvincia', dataType: "", hideOnEdit: false, caption: "Provincia",
          maxSize: 2,
          maxLength: "2",
          width: 20 * aspect,
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'provincia',
            valueExpr: 'siglaProvincia',
            displayExpr: 'descrizione',
            static: false,
            related: ['descrizione|luogoProdProvincia']
  
          }
        },
        {
          type: 'campo', colVisible: false, dataField: 'luogoProdComuneIstat', dataType: "", hideOnEdit: false, caption: "istat",
          width: 25.7 * aspect, disabled: true
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
  
  
  
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "Autorizzazione RS", colSpan: "4" },
  
        {
          type: 'campo', colVisible: false, dataField: 'produttoreAutorizzazioneNumero', hideOnEdit: false, caption: "Numero",
          maxSize: 10,
          maxLength: "10",
          width: 12 * aspect,
        },
        {
          type: 'campoData', colVisible: false, dataField: "produttoreAutorizzazioneData", dataType: "datetime", editorType: "dxDateBox", hideOnEdit: false, caption: "Data",
          width: 17.44 * aspect, format: "dd/MM/yyyy",
        },
  
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      ]
  
    },
    {
      itemType: "group", groupDataField: 'destinatario', caption: "Destinatario", disabled: true, colCount: "3", data: [
        {
          type: 'campoSpecial', colVisible: false, dataField: 'copiaDatiAziendaDestinatario', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Copia I dati azienda', hideOnEdit: false,
  
          checkBox: {
            event: {
              type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
              key: 'copiaDatiAziendaDestinatario'
  
  
            }
  
          },
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        { type: 'empty', caption: "Dati Destinatario", colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '3' },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioDenominazione', dataType: "", hideOnEdit: false, caption: "Ragione Sociale",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
  
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioCodiceFiscale', dataType: "", hideOnEdit: false, caption: "Codice Fiscale",
          maxSize: 16,
          maxLength: "16",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" },
  
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
  
  
  
  
  
        /*{
          type: 'campo', colVisible: false, dataField: 'destinatarioContattoNome', dataType: "", hideOnEdit: false, caption: "Nome",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioContattoCognome', dataType: "", hideOnEdit: false, caption: "Cognome",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioContattoTelefono', dataType: "", hideOnEdit: false, caption: "Telefono",
          maxSize: 10,
          maxLength: "10",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioContattoEmail', dataType: "", hideOnEdit: false, caption: "Email",
          maxSize: 30,
          maxLength: "30",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        */
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioVia', dataType: "", hideOnEdit: false, caption: "Indirizzo",
          maxSize: 30,
          maxLength: "30",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioCivico', dataType: "", hideOnEdit: false, caption: "Civico",
          maxSize: 8,
          maxLength: "8",
          width: 8 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioCitta', dataType: "", hideOnEdit: false, caption: "Citta",
          maxSize: 30,
          maxLength: "30",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campoSpecial', dataField: "destinatarioComune", caption: "Comune", dataType: "",
          maxSize: 30,
          maxLength: "30",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          dynamic: {
            costantValue: [{ key: 'destinatarioPaese', value: 'IT' }],
            dataSource: 'comune',
            autocomplete: true,
            checkValue: {
              checkValueMessage: '',
              forceInsert: false
            },
            valueExpr: '',//Lasciato Vuoto se non serve l'id del DB
            displayExpr: 'descrizione',
            caption: "Lista Comuni",
            componentType: 'grid',
            related: ['cap|destinatarioCap', 'siglaProvincia|destinatarioSiglaProvincia', "id|destinatarioIstat"],
            enableEditor: {
              add:true,
              remove:true,
              update:true
            },
            buttonOption: {
              text: 'Comuni',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Comuni',
              name: 'Comuni',
              location: 'after',
            },
  
          }
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'destinatarioPaese', dataType: "", hideOnEdit: false, caption: "Stato",
          maxSize: 2,
          maxLength: "2",
          width: 21.4 * aspect,
          editorType: 'dxSelectBox',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'StatoEstero',
            valueExpr: 'iso',
            displayExpr: 'descrizione',
            static: false,
            related: ['descrizione|destinatarioPaeseDescrizione']
          },
  
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioCap', caption: 'CAP', dataType: "", hideOnEdit: false,
          maxSize: 5,
          maxLength: "5",
          width: 8 * aspect,
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: "destinatarioSiglaProvincia", dataType: "", hideOnEdit: false, caption: "Provincia",
          maxSize: 2,
          maxLength: "2",
          width: 20 * aspect,
          editorType: 'dxSelectBox',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'provincia',
            valueExpr: 'siglaProvincia',
            displayExpr: 'descrizione',
            static: false,
            related: ["descrizione|destinatarioProvincia"],
  
          }
        },
        { type: 'campo', disabled: true, colVisible: false, dataField: 'destinatarioIstat', dataType: "", hideOnEdit: false, caption: "istat" },
  
        { type: 'empty', colSpan: "3", colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: 'Autorizzazione RS' },
  
        {
          type: 'campo', colVisible: false, dataField: 'destinatarioAutorizzazioneNumero', hideOnEdit: false, caption: "Numero",
          maxSize: 10,
          maxLength: "10",
          width: 10 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ]
        },
        {
          type: 'campoData', colVisible: false, dataField: "destinatarioAutorizzazioneData", dataType: "datetime", editorType: "dxDateBox", hideOnEdit: false, caption: "Data",
          width: 18 * aspect, format: "dd/MM/yyyy",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ]
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      ]
  
    },
    {
      itemType: "group", groupDataField: 'trasportatori', caption: "Trasportatori", disabled: true, colCount: "3", data: [
        {
          type: 'campoSpecial', colVisible: false, dataField: 'copiaDatiAziendaTrasportatore', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Copia dati azienda', hideOnEdit: false,
  
          checkBox: {
            event: {
              type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
              key: 'copiaDatiAziendaTrasportatore'
  
  
            }
  
          },
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
  
        { type: 'empty', caption: "Dati Trasportatore", colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '3' },
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriDenominazione', dataType: "", hideOnEdit: false, caption: "Ragione Sociale",
          maxSize: 45,
          maxLength: "45",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriCodiceFiscale', dataType: "", hideOnEdit: false, caption: "Codice Fiscale",
          maxSize: 16,
          maxLength: "16",
          width: 49.87 * aspect,
  
          validation: [
            { type: "required", message: "Campo Obbligatorio" },
  
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        { type: 'campo', colVisible: false, dataField: 'idTrasportatore', dataType: "", hideOnEdit: true, colSpan: '3' },
  
  
        /* {
           type: 'campo', colVisible: false, dataField: 'trasportatoriContattoNome', dataType: "", hideOnEdit: false, caption: "Nome",
           maxSize: 45,
           maxLength: "45",
           width: 45 * aspect,
           validation: [
             { type: "required", message: "Campo Obbligatorio" }
           ]
         },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
    
         {
           type: 'campo', colVisible: false, dataField: 'trasportatoriContattoCognome', dataType: "", hideOnEdit: false, caption: "Cognome",
           maxSize: 45,
           maxLength: "45",
           width: 45 * aspect,
    
           validation: [
             { type: "required", message: "Campo Obbligatorio" }
           ]
         },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
    
         {
           type: 'campo', colVisible: false, dataField: 'trasportatoriContattoTelefono', dataType: "", hideOnEdit: false, caption: "Telefono",
           maxSize: 13,
           maxLength: "13",
           width: 45 * aspect,
           validation: [
             { type: "required", message: "Campo Obbligatorio" }
           ]
         },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
    
         {
           type: 'campo', colVisible: false, dataField: 'trasportatoriContattoEmail', dataType: "", hideOnEdit: false, caption: "Email",
           maxSize: 20,
           maxLength: "20",
           width: 45 * aspect,
           validation: [
             { type: "required", message: "Campo Obbligatorio" }
           ]
         },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
         { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
    
    */
  
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriVia', dataType: "", hideOnEdit: false, caption: "Indirizzo",
          maxSize: 35,
          maxLength: "35",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriCivico', dataType: "", hideOnEdit: false, caption: "Civico",
          maxSize: 7,
          maxLength: "7",
          width: 7 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriCitta', dataType: "", hideOnEdit: false, caption: "Citta",
          maxSize: 35,
          maxLength: "35",
          width: 49.87 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
  
          type: 'campoSpecial', dataField: "trasportatoriComune", caption: "Comune", dataType: "",
          maxSize: 35,
          maxLength: "35",
          width: 49.87 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
  
  
          dynamic: {
            costantValue: [{ key: 'trasportatoriPaese', value: 'IT' }],
            dataSource: 'comune',
            autocomplete: true,
            checkValue: {
              checkValueMessage: '',
              forceInsert: false
            },
            valueExpr: '',//Lasciato Vuoto se non serve l'id del DB
            displayExpr: 'descrizione',
            caption: "Lista Comuni",
            componentType: 'grid',
            related: ['cap|trasportatoriCap', 'siglaProvincia|trasportatoriSiglaProvincia', 'provincia|trasportatoriProvincia', "id|trasportatoriIstat"],
  
            enableEditor: {
              add:true,
              remove:true,
              update:true
            },
            buttonOption: {
              text: 'Comuni',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Comuni',
              name: 'Comuni',
              location: 'after',
            },
  
          }
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'trasportatoriPaese', dataType: "", hideOnEdit: false, caption: "Stato",
          maxSize: 2,
          maxLength: "2",
          width: 20 * aspect,
          editorType: 'dxSelectBox',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'StatoEstero',
            valueExpr: 'iso',
            displayExpr: 'descrizione',
            static: false,
            related: ['descrizione|trasportatoriPaeseDescrizione']
          },
  
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriCap', caption: 'CAP', dataType: "", hideOnEdit: false,
          maxSize: 5,
          maxLength: "5",
          width: 8 * aspect,
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: "trasportatoriSiglaProvincia", dataType: "", hideOnEdit: false, caption: "Provincia",
          maxSize: 2,
          maxLength: "2",
          width: 20 * aspect,
          editorType: 'dxSelectBox',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'provincia',
            valueExpr: 'siglaProvincia',
            displayExpr: 'descrizione',
            static: false,
            related: ["descrizione|trasportatoriProvincia"]
          }
        },
        { type: 'campo', colVisible: false, dataField: 'trasportatoriIstat', dataType: "", hideOnEdit: false, caption: "istat" },
  
  
        { type: 'empty', colSpan: "3", colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: 'Autorizzazione Albo' },
  
        {
          type: 'campo', colVisible: false, dataField: 'trasportatoriAutorizzazioneNumero', hideOnEdit: false, caption: "Numero",
          maxSize: 10,
          maxLength: "10",
          width: 10 * aspect,
        },
        {
          type: 'campoData', colVisible: false, dataField: "trasportatoriAutorizzazioneData", dataType: "datetime", editorType: "dxDateBox", hideOnEdit: false, caption: "Data",
          format: "dd/MM/yyyy",
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
      ]
  
    },
    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', caption: "Dati Trasporto", disabled: true, colCount: "4", data: [
  
        { type: 'empty', caption: 'Dati Partenza', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '4' },
  
        { type: 'campo', colVisible: false, dataField: 'idTrasportatore', dataType: "", hideOnEdit: true },
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteNome', dataType: "", hideOnEdit: false, caption: "Nome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteCognome', dataType: "", hideOnEdit: false, caption: "Cognome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaAutomezzo', dataType: "", hideOnEdit: false, caption: "Targa Automezzo",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 10,
          maxLength: "10",
          width: 18.2 * aspect,
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaRimorchio', dataType: "", hideOnEdit: false, caption: "Targa Rimorchio",
          maxSize: 10,
          maxLength: "10",
          width: 18.2 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campoData', colVisible: false, dataField: 'datiTrasportoPartenzaDataInizioTrasporto', caption: 'Data inizio trasporto', dataType: "datetime", editorType: 'dxDateBox', hideOnEdit: false,
          format: 'dd/MM/yyyy',
          width: 18.2 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campoData', colVisible: false, dataField: 'datiTrasportoPartenzaOraInizioTrasporto', caption: 'Ora inizio trasporto', dataType: "time", editorType: 'dxDateBox', hideOnEdit: false,
          mask: 'HH:mm',
          width: 18.2 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        { type: 'campo', caption: 'Annotazione', colVisible: false, dataField: 'datiTrasportoPartenzaAnnotazioni', dataType: "", hideOnEdit: false, colSpan: "4", editorType: 'dxTextArea' },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '4' },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        {
          type: 'simpleButton', dataField: "Salta",
  
          button: {
  
            name: "Salta Inserimento Dati Trasporto",
            event: "Salta",
            type: "normal",
            hint: "ottieni le coordinate",
            icon: "mdi mdi-google-maps",
            componentType: '',
            componentOutPut: "",//funzione
  
  
          }
        },
      ]
  
    },
    {
      itemType: "group", groupDataField: 'rifiuto', caption: "Dati  Rifiuto", disabled: true, colCount: "5", data: [
  
        { type: 'empty', caption: 'Caratteristiche Rifiuto', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '5' },
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'rifiutoCodiceEer', caption: 'Codice CER', dataType: "",
          hideOnEdit: false,
  
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          width: 25 * aspect,
          dynamic: {
            dataSource: 'cer',
            autocomplete: false,
            checkValue: {
              checkValueMessage: '',
              forceInsert: false
            },
            valueExpr: 'id',//Lasciato Vuoto sen non serve l'id del DB
            displayExpr: 'id',
            caption: "Lista EER",
            componentType: 'grid',
            related: ['descrizione|descrizioneRifiuto'],
            enableEditor: {
              add:true,
              remove:true,
              update:true
            },
  
            buttonOption: {
              text: 'cer',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista EER',
              name: 'CER',
              location: 'after',
            },
  
          }
        },
        {
          type: 'campo', colVisible: false, dataField: 'descrizioneRifiuto', dataType: "", hideOnEdit: false,
          width: 25 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campoSpecial', caption: 'Stato Fisico', colVisible: false, dataField: 'statoFisico', dataType: "", hideOnEdit: false,
          editorType: 'dxSelectBox',
          width: 25 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'RentriOld/getCatalogo?_domain=stati-fisici',
            displayExpr: 'nome',
            valueExpr: 'codice'
          }
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campoSpecial', caption: 'Classi di Pericolo', colVisible: false, dataField: 'classiPericolo', dataType: "", hideOnEdit: false,
          width: 71 * aspect,
          editorType: "dxTagBox",
          tagBoxList: {
            dataSource: 'RentriOld/getCatalogo?_domain=classi-pericolo',
            displayExpr: 'nome',
            valueExpr: 'codice',
            maxDisplayedTags: 4,
            multiline: false,
            showSelectionControls: true
  
          }
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        {
          type: 'campo', colVisible: false, dataField: 'caratteristicheChimicoFisiche', caption: "Carat. Chimino Fisiche", dataType: "", hideOnEdit: false,
          width: 71 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false },
  
        { type: 'campo', colVisible: false, dataField: 'numeroColli', dataType: "", hideOnEdit: false, width: 25 * aspect, },
        { type: 'campo', colVisible: false, dataField: 'tipoImballaggio', dataType: "", hideOnEdit: false, width: 25 * aspect },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
        { type: 'empty', caption: 'Quantità Rifiuto', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '5' },
  
        {
          type: 'campo', colVisible: false, dataField: 'valore', dataType: "number", hideOnEdit: false, caption: 'Quantità',
          width: 15 * aspect,
          maxLength: '10',
  
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'pesolordo', dataType: "number", caption: 'Peso lordo', hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campo', colVisible: false, dataField: 'tara', dataType: "number", hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'um', dataType: "", hideOnEdit: false, caption: 'Unità misura',
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'um',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: true
          },
          width: 15 * aspect,
  
        },
        { type: 'campo', colVisible: false, dataField: 'verificareADestino', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Verificare a destino', hideOnEdit: false },
  
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'destinazioneRifiuto', caption: 'Destinazione Rifiuto',
          editorType: 'dxTagBox',
          hideOnEdit: false,
          width: 70 * aspect,
  
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          tagBoxList: {
            dataSource: 'OperazioneSmaltimento',
            valueExpr: 'id',
            displayExpr: 'id',
            showSelectionControls: true,
            maxDisplayedTags: 4,
            multiline: false,
  
  
          }
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
  
  
        { type: 'campo', colVisible: false, dataField: 'percorso', dataType: "", hideOnEdit: false, colSpan: '5' },
  
        { type: 'empty', caption: 'Normativa ADR', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '5' },
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'numeroONU', dataType: "", hideOnEdit: false, editorType: 'dxSelectBox',
          width: 35 * aspect,
          lista: {
            dataSource: 'RentriOld/getCatalogo?_domain=numeri-onu-adr',
            valueExpr: 'codice',
            displayExpr: 'nome',
            static: false
          },
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'classeADR', dataType: "", hideOnEdit: false,
          editorType: 'dxSelectBox',
          width: 35 * aspect,
          lista: {
            dataSource: 'RentriOld/getCatalogo?_domain=classi-adr',
            valueExpr: 'codice',
            displayExpr: 'nome'
  
          },
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
        /* { type: 'campo', colVisible: false, dataField: 'gruppoImballaggio', dataType: "", hideOnEdit: true, editorType: 'dxSelectBox',
        width:25 *aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: true, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: true, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: true, },*/
  
        {
          type: 'campo', colVisible: false, dataField: 'noteADR', dataType: "", hideOnEdit: false,
          width: 70 * aspect,
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
        { type: 'campo', colVisible: false, dataField: 'datiRifiutoAnnotazioni', dataType: "", editorType: 'dxTextArea', hideOnEdit: false, colSpan: '5' },
  
      ]
  
    }
  ]